// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hide a bunch of stuff when we're in audio-only mode. */
.vjs-audio-only .vjs-tech,
.vjs-audio-only .vjs-poster,
.vjs-audio-only .video-js {
  display: none !important;
  background-color: transparent;
}

.video-js {
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./node_modules/@jellyvision/storybook-runtime/dist/StorybookRuntime/components/ui/audioPlayer.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;;;EAGE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["/* Hide a bunch of stuff when we're in audio-only mode. */\n.vjs-audio-only .vjs-tech,\n.vjs-audio-only .vjs-poster,\n.vjs-audio-only .video-js {\n  display: none !important;\n  background-color: transparent;\n}\n\n.video-js {\n  background-color: transparent;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
